module.exports = __webpack_public_path__ + "static/media/download.0620e4b9.svg";